import {Injectable} from '@angular/core';
import {VerifyRequestApi} from '../api/request-verify.api';
import {CplUserRequest} from '../model/cpl-user-request.model';
import {UserRequestVerification} from '../model/request/user-request-verification-action.model';

@Injectable()
export class RequestVerifyService {
    constructor(
        private verifyApi: VerifyRequestApi
    ) {

    }

    verify = (cycleVerification: UserRequestVerification) =>  this.verifyApi.verify(cycleVerification);

    bulkVerify = (cycleVerification: UserRequestVerification[]) => this.verifyApi.bulkVerify(cycleVerification);
    
    reassign = (userRequest: CplUserRequest) => this.verifyApi.reassign(userRequest);

    submitForVerification = (userRequest: CplUserRequest) => this.verifyApi.submitForVerification(userRequest);

    submitFollowup = (userRequest: CplUserRequest) => this.verifyApi.submitFollowup(userRequest);
    
    // End Users can Cancel and Restore Requests
    // For now, they can only submit one request at a time
    userVerification = (cycleVerification: UserRequestVerification) => this.verifyApi.userVerification(cycleVerification);

    getVerifyHistoryByUserRequestId = (userRequestId: string) => this.verifyApi.getVerifyHistoryByUserCycleId(userRequestId);
}